#version 300 es
    
precision highp float;
precision highp sampler3D;

in vec3 pass_textureCoordinates;

out float color;

uniform sampler3D sampler;

uniform float minValue;

void main() {
    color = texture(sampler, pass_textureCoordinates).r - minValue;
}